import script from "./OnboardingIdentityDocumentsForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnboardingIdentityDocumentsForm.vue?vue&type=script&setup=true&lang=ts"

import "./OnboardingIdentityDocumentsForm.vue?vue&type=style&index=0&id=69d68380&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69d68380"]])

export default __exports__